import type {ComponentType, ReactElement} from 'react';
import {createElement} from 'react';
import {EmailMakerSaveErrorCode} from '@EmailMakerReact/lib/email-maker-storage-library';
import {DefaultSaveErrorDetail} from './components/default-save-error-detail/default-save-error-detail';
import {InvalidLinksSaveErrorDetail} from './components/invalid-links-save-error-detail/invalid-links-save-error-detail';
import type {EmailMakerSaveErrorPopupProps, SaveErrorDetailProps} from './email-maker-save-error-popup.types';
import styles from './email-maker-save-error-popup.module.scss';

/** Registry mapping error codes to their custom detail components. Adding a future custom UI requires only a new component and one entry here. */
const SAVE_ERROR_DETAIL_BY_CODE: Partial<Record<EmailMakerSaveErrorCode, ComponentType<SaveErrorDetailProps>>> = {
  [EmailMakerSaveErrorCode.INVALID_CAMPAIGN_URLS]: InvalidLinksSaveErrorDetail,
};

function resolveSaveErrorDetail(code: EmailMakerSaveErrorCode | null): ComponentType<SaveErrorDetailProps> {
  const custom = code === null ? undefined : SAVE_ERROR_DETAIL_BY_CODE[code];
  return custom ?? DefaultSaveErrorDetail;
}

/** Presentational card body shared by the desktop inline popover and the phone modal panel; lists invalid links as clickable rows that reveal their text component on the canvas. */
export function EmailMakerSaveErrorPopup({saveError, onClose}: EmailMakerSaveErrorPopupProps): ReactElement {
  const detailComponent = resolveSaveErrorDetail(saveError.code);
  return <div className={`${styles.popup} flex-v-row gap-2 spacing-p-4`}>{createElement(detailComponent, {saveError, onClose})}</div>;
}
